
import React from "react";
import { Link } from "react-router-dom";

const AdminTopbar = ({
    setSidebarOpen,
}) => {

    return (
        <header className="admin-topbar">

            <div className="admin-topbar-left">

                <button
                    type="button"
                    className="admin-mobile-menu"
                    onClick={() =>
                        setSidebarOpen(true)
                    }
                    aria-label="Open admin menu"
                >
                    ☰
                </button>


                <div>

                    <span className="admin-topbar-label">
                        ADMINISTRATION
                    </span>

                    <h1>
                        Website Management
                    </h1>

                </div>

            </div>


            <div className="admin-topbar-right">

                {/* View Website */}

                <Link
                    to="/"
                    target="_blank"
                    className="admin-view-site"
                >
                    <span>
                        ↗
                    </span>

                    View Website
                </Link>


                {/* Notification */}
{/* 
                <button
                    type="button"
                    className="admin-notification"
                    aria-label="Notifications"
                >

                    ♧

                    <span>
                        3
                    </span>

                </button> */}


                {/* Profile */}

                <div className="admin-topbar-profile">

                    <div className="admin-topbar-avatar">
                        A
                    </div>

                    <div>

                        <strong>
                            Administrator
                        </strong>

                        <span>
                            Super Admin
                        </span>

                    </div>

                    <span className="admin-profile-arrow">
                        ▾
                    </span>

                </div>

            </div>

        </header>
    );
};

export default AdminTopbar;

